export interface GetCaseMovementListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetCaseMovementListPagingAndFilterResponseData
}

export interface GetCaseMovementListPagingAndFilterResponseData {
    items: GetCaseMovementListPagingAndFilterResponseItem[]
    totalRecordCount: number
    totals: GetCaseMovementListPagingAndFilterResponseTotals | undefined
}

/** Görüntülenen sayfadaki kayıtların dip toplamı. */
export interface GetCaseMovementListPagingAndFilterResponseTotals {
    /** Döviz bazında gruplanmış metin: "1.250,00 TRY, 45,00 USD" */
    price: string
    rowCount: number
}

export interface GetCaseMovementListPagingAndFilterResponseItem {
    caseMovementId: string
    companyId: string
    refNo: string
    caseMovementTypeId: string
    caseId: string
    price: number
    processDate: string
    description: string
    isCustomActive: boolean
    currentCompanyId?: string
    caseMovementTypeName: string
    caseMovementTypeKey: string
    caseName: string
    currentCompanyName?: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetCaseMovementListPagingAndFilterResponseData: GetCaseMovementListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0,
    totals: undefined
}